"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphql = exports.API = exports.Auth = exports.Amplify = void 0;
const graphql = __importStar(require("./graphql"));
exports.graphql = graphql;
const amplifyBootstrap_1 = __importStar(require("./utils/amplifyBootstrap"));
exports.Amplify = amplifyBootstrap_1.default;
Object.defineProperty(exports, "Auth", { enumerable: true, get: function () { return amplifyBootstrap_1.Auth; } });
Object.defineProperty(exports, "API", { enumerable: true, get: function () { return amplifyBootstrap_1.API; } });
const amplifyConfig_1 = require("./utils/amplifyConfig");
__exportStar(require("./types"), exports);
__exportStar(require("./hooks"), exports);
__exportStar(require("./utils"), exports);
const defaultConfig = (0, amplifyConfig_1.buildAmplifyConfig)();
exports.default = defaultConfig;
